var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSoh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "570.000000pt",
    height: "531.000000pt",
    viewBox: "0 0 570.000000 531.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,531.000000) scale(0.100000,-0.100000)",
    fill: "#6eb0b1",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1816 4880 c-63 -25 -128 -88 -158 -154 l-23 -51 0 -865 0 -865 28 -57 c32 -64 80 -111 146 -142 46 -21 50 -21 1051 -21 l1005 0 57 28 c64 32 111 80 142 146 21 46 21 53 21 906 0 975 5 913 -83 1007 -79 85 -98 88 -482 88 l-330 0 0 -245 0 -246 -25 -24 c-40 -41 -75 -33 -190 40 -56 36 -108 65 -115 65 -7 0 -57 -29 -111 -65 -117 -76 -162 -85 -198 -39 -20 25 -21 39 -21 270 l0 244 -332 0 c-304 -1 -337 -3 -382 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1750 2056 c0 -241 0 -245 -23 -271 -38 -45 -79 -37 -186 34 -50 34 -98 64 -105 67 -8 3 -60 -25 -116 -63 -84 -55 -110 -68 -142 -68 -30 0 -45 6 -59 24 -17 21 -19 43 -19 268 l0 244 -347 -3 c-337 -3 -349 -4 -389 -25 -63 -34 -97 -66 -129 -125 l-30 -53 -3 -859 c-2 -744 0 -866 13 -912 20 -68 87 -143 157 -175 l53 -24 1005 0 c1003 0 1005 0 1051 21 60 28 116 85 145 148 l24 51 0 861 c0 968 4 914 -76 1003 -26 29 -65 58 -96 72 -52 24 -59 24 -390 27 l-338 3 0 -245z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4627 2294 c-4 -4 -7 -115 -7 -246 0 -137 -4 -247 -10 -258 -14 -26 -65 -42 -98 -29 -15 6 -68 37 -119 71 l-92 60 -113 -71 c-115 -73 -134 -79 -171 -59 -45 24 -46 31 -47 286 l0 243 -347 -3 c-338 -3 -349 -4 -390 -25 -55 -30 -107 -84 -135 -142 l-23 -46 0 -870 0 -870 28 -57 c32 -64 80 -111 146 -142 46 -21 50 -21 1051 -21 1001 0 1005 0 1051 21 66 31 114 78 146 142 l28 57 0 865 0 865 -24 52 c-26 59 -99 133 -157 160 -34 15 -78 18 -374 21 -185 2 -339 0 -343 -4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoh);
export default __webpack_public_path__ + "static/media/soh.690d05c090b5c51f615730423f973d7f.svg";
export { ForwardRef as ReactComponent };